import * as types from "_graphql-types/graphql";

export const PerformanceStatOptions = [
  {
    label: "1M",
    statType: types.PerformanceStatType.CompoundReturn1m,
  },
  {
    label: "1Y",
    statType: types.PerformanceStatType.CompoundReturn1yAnnualized,
  },
  {
    label: "YTD",
    statType: types.PerformanceStatType.CompoundReturnYtd,
  },
  {
    label: "3Y",
    statType: types.PerformanceStatType.CompoundReturn3yAnnualized,
  },
  {
    label: "5Y",
    statType: types.PerformanceStatType.CompoundReturn5yAnnualized,
  },
];

export const PerformancePrivateStatOptions = [
  {
    label: "Net IRR",
    statType: types.PerformancePrivateStatType.NetIrr,
  },
  {
    label: "TVPI",
    statType: types.PerformancePrivateStatType.Tvpi,
  },
  {
    label: "DPI",
    statType: types.PerformancePrivateStatType.Dpi,
  },
];

export function getPerformanceStatLabel(
  statType: types.PerformanceStatType | types.PerformancePrivateStatType
) {
  return (
    [...PerformanceStatOptions, ...PerformancePrivateStatOptions].find(
      option => option.statType === statType
    )?.label ?? statType
  );
}
